import Vue from 'vue'

Vue.filter('currency', amount => {
	return '$' + amount
})

Vue.filter('percentage', amount => {
	return amount + '%'
})


// WEBPACK FOOTER //
// ./src/filters.js